import type { ComposeTab } from '../composeActions';

/**
 * Multi-tool probe prompts — exercise the full query→draft→dispatch→
 * synthesize loop. Distinct from chips (one-tap fire) and Lab (templates);
 * probes are workflow validations.
 *
 * Growth slot per spec §2.5: ships near-empty (1 entry); promote to
 * richer corpus when substrate-validation work generates more probes.
 */
export const probesTab: ComposeTab = {
  id: 'probes',
  emoji: '🎯',
  label: 'Probes',
  descriptor: 'Workflow validations — full query→draft→dispatch→synthesize loops',
  actions: [
    {
      kind: 'insert',
      id: 'probe-blocker-report',
      label: 'Blocker report + peer review',
      descriptor:
        'Find attention items, draft a report, dispatch to 3 peers, synthesize. '
        + 'Exercises attention_items + consult_peers + synthesis. ~100-120s, 5 rounds.',
      prompt:
        'Find the current blockers in the task system, draft a brief written report, '
        + 'ask 3 colleagues to review it, then give me a synthesized recommendation.',
    },
  ],
};
